module.exports = __webpack_public_path__ + "static/img/RS2768_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RS2768_1.png
// module id = ju8q
// module chunks = 0